// Types
import CheckableSelect from 'components/CheckableSelect/CheckableSelect';
import TimeRange from 'components/TimeRange/TimeRange';
// Utils
import { getText } from 'i18n/intl';
import _ from 'lodash';
import { EWeekdays } from '@timeedit/types/lib/enums';
// Components
import { TEDrawerSection } from '@timeedit/ui-components';
import type { IProps } from './sections.interface';

const ActiveCriteria = ({ timeRule, onChange }: IProps) => {
  const isStandard = !timeRule.timeSlotSelection;
  return (
    <TEDrawerSection label={getText('time_rule_active_criteria')}>
      <div
        style={{ marginBottom: 30 }}
        className="section-wrapper"
        data-testid="time-range"
      >
        {isStandard && (
          <TimeRange
            label="Time range"
            tooltip="Time range"
            value={[timeRule.clockTimeStart, timeRule.clockTimeEnd]}
            onChange={(value) => {
              onChange({
                object: {
                  clockTimeStart: value?.[0],
                  clockTimeEnd: value?.[1],
                },
              });
            }}
          />
        )}
        <div data-testid="active-weekdays">
          <CheckableSelect
            label="Select weekday(s)"
            tooltip="Select weekday(s)"
            options={weekdayOptions}
            value={timeRule.weekdays}
            onChange={(value: EWeekdays[]) => {
              onChange({ key: 'weekdays', value });
            }}
            highlightValue={[EWeekdays.SUN]}
          />
        </div>
      </div>
    </TEDrawerSection>
  );
};

const weekdayOptions = Object.keys(EWeekdays).map((key) => ({
  value: key,
  label: _.capitalize(key),
}));

export default ActiveCriteria;
